import React from "react";
import "./Monard.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card";
import Monard8images from "../../../Media/BSD/Armont/Monard/Monard8";
import Monard9images from "../../../Media/BSD/Armont/Monard/Monard9";

const imageMap = {
  Monard8images,
  Monard9images,

  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="vireya" className="produk">
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
